import { ImmutableLine3, ImmutableVector3 } from '@modugen/ui-toolkit'

/** World-space length of the perpendicular ticks at tapeline endpoints, in metres. */
export const TAPELINE_END_TICK_LENGTH = 0.2

const MIN_LINE_LENGTH = 0.01

export interface TapelineEndTickGeometry {
  startTick: ImmutableLine3
  endTick: ImmutableLine3
}

export const getTapelineEndTicks = (
  start: ImmutableVector3,
  end: ImmutableVector3,
  tickLength = TAPELINE_END_TICK_LENGTH,
): TapelineEndTickGeometry | null => {
  const directionXY = new ImmutableVector3(end.x - start.x, end.y - start.y, 0)
  if (directionXY.length() < MIN_LINE_LENGTH) return null

  const perp = new ImmutableVector3(-directionXY.y, directionXY.x, 0).normalize()
  const halfLength = tickLength / 2

  const tickAt = (point: ImmutableVector3): ImmutableLine3 =>
    new ImmutableLine3(
      point.addScaledVector(perp, -halfLength),
      point.addScaledVector(perp, halfLength),
    )

  return {
    startTick: tickAt(start),
    endTick: tickAt(end),
  }
}
